import Speech from 'speak-tts'


const speechLib = new Speech();
let voiceSetted = false;
class SpeechComponent {

    async ConfigSpeech(patient) {
        try {
            console.log('Configurando');
            if (speechLib.hasBrowserSupport()) { // returns a boolean
                window.speechSynthesis.onvoiceschanged = function () {
                    speechLib.init({
                        'volume': 1,
                        'lang': 'es-MX',
                        'pitch': 1,
                        'rate': 1
                    });
                    speechLib.setVoice(configVoiceWithBrowser());
                    if (patient != null && patient != undefined) {
                        let llamado = patient.nombre + ' por favor pasar a ' + patient.espacio;
                        speechLib.speak({ text: llamado });
                    }
                    voiceSetted = true;
                    return true;
                };
                return voiceSetted;
            }
            else {
                return false;
            }
        }
        catch (e) {
            return false;
        }
    }

    callPatientVoice(patient) {
        if (voiceSetted) {
            if (patient != null && patient != undefined) {
                let llamado = patient.nombre + ' por favor pasar a ' + patient.espacio;
                speechLib.speak({ text: llamado, });
            }
        }
    }
}

//Configuracion de Voz
function configVoiceWithBrowser() {
    window.speechSynthesis.cancel();
    let voices = window.speechSynthesis.getVoices();
    let sabina = voices.some(voice => voice.name == 'Microsoft Sabina - Spanish (Mexico)');//Voz Mexicana de Microsoft (S.O)
    if (sabina) {
        return 'Microsoft Sabina - Spanish (Mexico)';
    }
    else {
        return 'Microsoft Laura - Spanish (Spain)';
    }
}

export default new SpeechComponent();